'use client';

export const EmptyComponent = () => <></>;
